import cx from 'classnames';
import React from 'react';

import { Breadcrumbs } from '../../index';
import { Image } from '../../index';
import * as styles from './Banner.module.css';

const Banner = ({
	children,
	image,
	alt,
	breadcrumbs,
	pagePath,
	className = '',
	background,
}: {
	children: React.ReactNode;
	image?: object;
	alt?: string;
	breadcrumbs?: boolean;
	pagePath?: string;
	className?: string;
	background?: 'white' | null;
}) => {
	return (
		<section className={cx(styles.banner, styles[`${background}Background`], className)}>
			{breadcrumbs && pagePath && <Breadcrumbs pagePath={pagePath} />}

			{image && (
				<div className={styles.image}>
					<Image image={image} alt={alt ? alt : ''} lazy="eager" />
				</div>
			)}
			<div className={styles.layout}>
				{breadcrumbs && pagePath && <Breadcrumbs pagePath={pagePath} />}
				{children}
			</div>
		</section>
	);
};

export default Banner;
